import React, { ReactElement } from 'react';

interface Props {
  width?: number | string;
  height?: number | string;
  style?: React.CSSProperties;
}

const Location = (props: Props): ReactElement => {
  const { width, height, style } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 24 24" style={style}>
      <path
        fill="currentColor"
        d="M12 3c4.418 0 8 3.542 8 7.912C20 15.28 17.333 17.52 12 22c-5.333-4.48-8-6.72-8-11.088C4 6.542 7.582 3 12 3zm0 1.187c-3.756 0-6.8 3.01-6.8 6.725 0 3.714 2.202 5.502 6.69 9.424l.11.096.11-.096c4.44-3.88 6.69-5.71 6.69-9.424 0-3.714-3.044-6.725-6.8-6.725zm0 2.769c2.099 0 3.8 1.682 3.8 3.758 0 2.075-1.701 3.758-3.8 3.758-2.099 0-3.8-1.683-3.8-3.758 0-2.076 1.701-3.758 3.8-3.758zm0 1.186c-1.436 0-2.6 1.152-2.6 2.572 0 1.42 1.164 2.571 2.6 2.571 1.436 0 2.6-1.151 2.6-2.571 0-1.42-1.164-2.572-2.6-2.572z"
      />
    </svg>
  );
};

Location.defaultProps = {
  width: '100%',
  height: '100%',
  style: {},
};

export default Location;
